import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints, colors } : Theme) => createStyles({
  button: {
    fontSize: 16,
    height: 32,
    textTransform: 'unset',
    paddingTop: 2,
    paddingBottom: 2,
    color: '#018694',
    borderColor: '#018694',
    fontWeight: 700,
    width: '100%',
    maxWidth: 190,
  },
  title: {
    fontSize: 24,
    fontFamily: 'Montserrat',
    color: '#2D3950',

    [breakpoints.down('xs')]: {
      fontSize: 20,
    },
  },
  message: {
    fontSize: 16,
    fontFamily: 'Roboto',
    color: '#35405C',

    [breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  actionsContainer: {
    justifyContent: 'center',
    paddingBottom: 54,

    [breakpoints.down('xs')]: {
      paddingBottom: 34,
    },
  },
  contentContainer: {
    textAlign: 'center',
  },
  titleContainer: {
    textAlign: 'center',
    paddingTop: 72,

    [breakpoints.down('xs')]: {
      paddingTop: 52,
    },
  },
}));

export default useStyles;
